module.exports = __webpack_public_path__ + "fonts/NoirPro-Heavy.a302e546.woff";